define('vspot-angular/services/job-compose-service',['jquery'], function ($) {
    'use strict';

    /*
     *  A service used to pass information between activity-jobs, activity-jobs-compose, and job-shifts
     *  to provide a single true source of in-progress information
     */
    return [ function () {
        var shifts,
            jobTitles;
        // let the compose module know what the jobs module intends to create/edit
        var config = {
                activityData: {},
                addJobDate: '',
                job: {},
                jobParent: {},
                events: [],
                showJobCompose: false
        };

        return {
            getConfig: function() {
                return config;
            },
            setConfig: function(newData) {
                config = newData;
            },
            // temporary storage for shifts; only contains the shifts currently being created
            getShifts: function () {
                return shifts;
            },
            setShifts: function (newData) {
                shifts = newData;
            },
            getJobTitles: function () {
                return jobTitles;
            },
            setJobTitles: function (newData) {
                jobTitles = newData;
            },
            parseSelectedJobTitle: function($model) {
                return $('<textarea />').html($model).text();
            }
        };
    }];
});

